/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import * as solid from '@fortawesome/free-solid-svg-icons'

import * as regular from '@fortawesome/free-regular-svg-icons'

const installedIcons = [
    solid.faBars,
    solid.faKey,
    solid.faSignOutAlt,
    solid.faUserCircle,
    solid.faFileAlt,
    solid.faCalendarCheck,
    solid.faTimes,
    solid.faImage,
    solid.faCheck,
    solid.faFileContract,
    solid.faPlus,
    solid.faCalendarDay,
    solid.faPlus,
    solid.faUser,
    solid.faTicketAlt,
    solid.faExchangeAlt,
    solid.faMoneyCheckAlt,
    solid.faPortrait,
    solid.faBalanceScaleRight,
    solid.faTasks,
    solid.faReceipt,
    solid.faUndo,
    solid.faExternalLinkAlt,
    solid.faFont,
    solid.faCaretLeft,
    solid.faObjectGroup,
    solid.faAngleDoubleRight,
    solid.faAngleLeft,

    regular.faUser,
]

/* add icons to the library */
library.add(...installedIcons)

export default FontAwesomeIcon